import ReactDOM from "react-dom/client";
import "@arco-design/web-react/dist/css/arco.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./App";
import "./i18n.config";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setupAxios } from "./setupAxios";
import { bootstrapThemeFromHostname, applyDocumentTitleFromHostname } from "./theme";

import "./index.css";

const themeName = bootstrapThemeFromHostname();
applyDocumentTitleFromHostname();
document.body.classList.add(`theme-${themeName}`);

setupAxios();

let serviceWorkerRefreshPending = false;
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (serviceWorkerRefreshPending) {
      return;
    }
    serviceWorkerRefreshPending = true;
    window.location.reload();
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
);
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register({
    onUpdate(registration) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: "SKIP_WAITING" });
      }
    },
  });
} else {
  // Dev server restarts change chunk hashes; a stale SW causes ChunkLoadError.
  serviceWorkerRegistration.unregister();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
